export const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-@#$%^&+=!_"'()~|[\]`;:*{},./<>?¥])(?!.*\s).{8,12}$/;
